import React from "react";
import { Helmet } from "react-helmet";
import { NavLink } from 'react-router-dom';


function ArticlesHome()
{
    // Create a new request object

    //load the json file
    var xhr = new XMLHttpRequest();


    //var url = "https://api.github.com/repos/lcsrodriguez/articles/git/trees/main"
    var URL_ARTICLES_LIST = "https://raw.githubusercontent.com/lcsrodriguez/articles/main/list.json";

    // L'usage de l'API GitHub n'est pas une bonne idée
    xhr.open("GET", URL_ARTICLES_LIST, false);
    //xhr.setRequestHeader("Accept", "application/vnd.github.v3+json");
    //xhr.setRequestHeader("Authorization", "token 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");
    xhr.send();

    //console.log(xhr.responseText)
    var json = JSON.parse(xhr.responseText);
    // console.log(json)
    var elts = Object.values(json);
    // console.log(elts);

    return (
        <div>
            <Helmet>
                <title>Articles | Lucas RODRIGUEZ</title>
            </Helmet>
            <h2>Articles</h2>
            <p>
                List of the posts written over the last years:
                {/* For each article, a dedicated <a href="https://medium.com/@lcsrodriguez" target="_BLANK">Medium</a> version is available online. */}
            </p>

            <div className="row">
                <div className="col-md-8">
                    <ol class="list-group list-group-numbered">
                        {elts.map((value) =>
                        {
                            if (value.visible)
                            {
                                console.log("Show article " + value.slug + value.title)
                                var link = "/articles/" + value.slug;
                                return (<li class="list-group-item d-flex justify-content-between align-items-start">
                                    <div class="ms-2 me-auto">
                                        <NavLink to={link}>
                                            <div class="fw-bold">{value.title}</div>
                                        </NavLink>
                                        <i>{value.keywords}</i>
                                    </div>
                                    <span class="badge bg-black rounded-pill">{value.date}</span>
                                </li>) // <li><NavLink to={link}>{value.title}</NavLink> ◇ <small><i>{value.date}</i></small></li>
                            }
                        })
                        }
                    </ol>
                    <p className="text-muted small" style={{ marginTop: "30px" }}>
                        Open to any contributions (improvements, remarks, typos, ...)
                    </p>
                </div>
            </div>
        </div>

    );
}

export default ArticlesHome; 